import { useLingui } from '@lingui/react/macro'
import { Text } from 'designSystem/components/Text'
import {
  MetaLabel,
  MetaRow,
  MetaValue,
} from 'features/knowledgeDocumentViewer/components/metadata/metadataFieldListStyles'
import { metadataFieldLabelMessage } from 'features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages'
import React from 'react'

export type MetadataFieldRowProps = {
  label: string
  value: string
  valueControl?: React.ReactNode
}

export function MetadataFieldRow({
  label,
  value,
  valueControl,
}: MetadataFieldRowProps): React.ReactElement {
  const { t, i18n } = useLingui()
  const valueText = (
    <Text variant='body'>
      {value || (
        <Text as='span' color='muted' italic>
          {t`Not set`}
        </Text>
      )}
    </Text>
  )

  return (
    <MetaRow>
      <MetaLabel>
        <Text variant='body' color='muted'>
          {i18n._(metadataFieldLabelMessage(label))}
        </Text>
      </MetaLabel>
      <MetaValue>{valueControl ?? valueText}</MetaValue>
    </MetaRow>
  )
}
